"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCustomEvent = exports.isBrowser = exports.isServer = void 0;
const isServer = () => typeof window === 'undefined';
exports.isServer = isServer;
const isBrowser = () => !(0, exports.isServer)();
exports.isBrowser = isBrowser;
function isCustomEvent(event) {
    return typeof event.forDriver === 'function';
}
exports.isCustomEvent = isCustomEvent;
//# sourceMappingURL=fns.js.map